export const POST_SALE_SECTIONS = ['gestao', 'prioridades', 'vendas'];

const MANAGEMENT_PERMISSIONS = ['administrator', 'post_sale_manage'];

export const canManagePostSale = (permissions = []) =>
  MANAGEMENT_PERMISSIONS.some(permission => permissions.includes(permission));

export const postSaleInitialSection = (permissions = []) =>
  canManagePostSale(permissions) ? 'gestao' : 'vendas';

export const normalizePostSaleSection = (section, fallback = 'gestao') =>
  POST_SALE_SECTIONS.includes(section) ? section : fallback;
